/* Flowtica — inline product cards in blog articles.
 * Renders a product card wherever an article contains either:
 *   1) an HTML element with data-flowtica-product="product-handle"  (recommended, degrades to nothing)
 *   2) a paragraph whose only text is [[product:product-handle]]    (convenience syntax)
 */
(function () {
  var CONTAINER = '.article-template__content';
  var TOKEN = /^\s*\[\[\s*product\s*:\s*([a-z0-9][a-z0-9\-_]*)\s*\]\]\s*$/i;
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(cents) {
    var amount = (cents || 0) / 100;
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); });
    return cache[handle];
  }

  function fill(el, p) {
    var url = p.url || ('/products/' + p.handle);
    var img = sized(p.featured_image || (p.images && p.images[0]) || '', 240);
    var hasSale = p.compare_at_price && p.compare_at_price > p.price;
    el.className = 'fl-product-card';
    el.removeAttribute('aria-busy');
    el.innerHTML =
      '<a class="fl-product-card__media" href="' + esc(url) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="120">' : '') +
      '</a>' +
      '<div class="fl-product-card__body">' +
        '<a class="fl-product-card__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        '<div class="fl-product-card__price">' +
          '<span class="fl-product-card__price-now">' + money(p.price) + '</span>' +
          (hasSale ? '<span class="fl-product-card__price-was">' + money(p.compare_at_price) + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<div class="fl-product-card__cta">' +
        '<a class="button fl-product-card__btn" href="' + esc(url) + '">Shop Now</a>' +
      '</div>';
  }

  function mount(el, handle) {
    el.className = 'fl-product-card fl-product-card--loading';
    el.setAttribute('aria-busy', 'true');
    fetchProduct(handle).then(function (p) { fill(el, p); }).catch(function () {
      // product missing / unpublished: remove the placeholder silently
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function run() {
    var root = document.querySelector(CONTAINER);
    if (!root) return;

    // 1) explicit data-attribute elements (recommended)
    root.querySelectorAll('[data-flowtica-product]').forEach(function (el) {
      var h = (el.getAttribute('data-flowtica-product') || '').trim();
      if (h) mount(el, h);
    });

    // 2) [[product:handle]] tokens sitting alone in a block element
    var blocks = root.querySelectorAll('p, div, li, span');
    Array.prototype.forEach.call(blocks, function (el) {
      if (el.querySelector('[data-flowtica-product], .fl-product-card')) return;
      if (el.children.length) return;
      var m = (el.textContent || '').match(TOKEN);
      if (m) mount(el, m[1]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
